import { useState, useEffect, useRef } from "react";
import SidebarComponent from "../SideBar/SideBarComponent";
import Header from "../Header/Header";
import ScheduleTab from "../SchedulingPage/ScheduleTab";
import DashboardTab from "../DashboardPage/DashboardTab";
import StudentManagementTab from "../StudentManagementPage/StudentManagementTab";
import InterviewConfigTab from "../InterviewConfigPage/InterviewConfigTab";
import { SIDE_BAR_ITEMS } from "../features/common/Constants";
import InterviewReviewTab from "../InterviewReviewPage/InterviewReviewTab";
import ReportEvaluationTab from "../ReportEvaluationPage/ReportEvaluationTab";
import GlobalLoader from "../features/common/GlobalLoader";
import "./Style.css";
import QuestionDatabaseTab from "../QuestionDatabase/QuestionDatabaseTab";
import SettingsTab from "../SettingsPage/SettingsTab";
import AdminHeader from "../Header/AdminHeader";

const DashboardPage = () => {
  const [activePage, setActivePage] = useState(() => {
  return sessionStorage.getItem("admin_active_page") || SIDE_BAR_ITEMS.DASHBOARD;
  });

  const [isLoading, setIsLoading] = useState(true);
  const previousPageRef = useRef(activePage);
  const loadingTimeoutRef = useRef(null);

  useEffect(() => {
    loadingTimeoutRef.current = setTimeout(() => {
      setIsLoading(false);
    }, 300);

    return () => {
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
  sessionStorage.setItem("admin_active_page", activePage);
}, [activePage]);


  useEffect(() => {
    if (previousPageRef.current !== activePage) {
      setIsLoading(true);
      
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current);
      }
      
      loadingTimeoutRef.current = setTimeout(() => {
        setIsLoading(false);
      }, 300);
      
      previousPageRef.current = activePage;
    }

    return () => {
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current);
      }
    };
  }, [activePage]);
  const renderContent = () => {
    switch (activePage) {
      case SIDE_BAR_ITEMS.DASHBOARD:
        return <DashboardTab activeMenu={activePage} setActivePage={setActivePage} />;
      case SIDE_BAR_ITEMS.STUDENT_MANAGEMENT:
        return <StudentManagementTab activeMenu={activePage} />;
      case SIDE_BAR_ITEMS.INTERVIEW_CONFIG:
        return <InterviewConfigTab  />;
      case SIDE_BAR_ITEMS.INTERVIEW_REVIEWS:
        return <InterviewReviewTab activeMenu={activePage} />;
      case SIDE_BAR_ITEMS.QUESTION_DATABASE:
        return <QuestionDatabaseTab />;
      case SIDE_BAR_ITEMS.SCHEDULING:
        return <ScheduleTab />;
      case SIDE_BAR_ITEMS.REPORT_EVALUATION:
        return <ReportEvaluationTab activeMenu={activePage}/>;  
      case SIDE_BAR_ITEMS.SETTINGS:
        return <SettingsTab />;
      default:
        return (
          <>
            <Header />
          </>
        );
    }
  };

  const handleSetActivePage = (page) => {
    setActivePage(page);
  };

  return (
    <div className="dashboard-page-root">
      <AdminHeader />
    <div className="dashboard-page-container">
      <SidebarComponent activePage={activePage} setActivePage={handleSetActivePage} />
      <div className="dashboard-page-content-wrapper">
        <div className="dashboard-page-main">
          <div className="dashboard-page-content">
            {renderContent()}
          </div>
        </div>
      </div>
      {isLoading && <GlobalLoader />}
    </div>
    </div>
  );
};

export default DashboardPage;
